// extracted by mini-css-extract-plugin
export default {"light":"BaseLayout_light__ldtJE","footer":"BaseLayout_footer__qwRL3"};